export const ROUTES = {
  MAIN: "/",
  SUBSCRIPTION: "/subscription",
  ALERT_NEW: "/alert/new",
  ALERT_EDIT: "/alert/:id",
  STATS: "/stats",
  TERMS: "/terms",
  PRIVACY: "/privacy",
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];

export function getAlertEditRoute(id: number | string): string {
  return `/alert/${id}`;
}
